import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Marca } from '../models/marca';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class MarcaService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarMarcas() {
    return this.http.get<Marca[]>(globals.apiUrl + '/api/Marca/Lista');
  }

  consultarPorIdMarca(idMarca) {
    return this.http.get<any>(globals.apiUrl + '/api/Marca/Buscar',
      { params: new HttpParams().set('id', idMarca) });
  }

  salvar(marca) {
    return this.http.post(globals.apiUrl + '/api/Marca/Salvar', marca);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Marca/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  listarPorFamilia(idFamilia, todos?, somenteExistentes?) {
    return this.http.get<any>(globals.apiUrl + '/api/Marca/ListarPorFamilia',
      { params: new HttpParams().set('idFamilia', idFamilia).set('somenteAtivos', todos === null || todos === undefined ? 'true' : 'false').set('somenteExistentes', somenteExistentes === null || somenteExistentes === undefined ? 'false' : 'true') });
  }

  listarPorCategoria(idCategoria, todos?, somenteExistentes?) {
    return this.http.get<any>(globals.apiUrl + '/api/Marca/ListarPorCategoria',
      { params: new HttpParams().set('idCategoria', idCategoria).set('somenteAtivos', todos === null || todos === undefined ? 'true' : 'false').set('somenteExistentes', somenteExistentes === null || somenteExistentes === undefined ? 'false' : 'true') });
  }

  buscarMarcasInversoresDisponiveis(filtroCombinacao) {
    return this.http.post<any>(globals.apiUrl + '/api/Marca/ListarMarcasInversoresPorFiltro', filtroCombinacao);
  }
}
